import { SravniNewsSharedModelsLikesUserLikesResult } from '../__generated__/news/Api';
import { IGlobalState } from '../reducers';

export const getIsArticleLikedByCurrentUser = (articleId) => {
  return (state: IGlobalState): boolean | undefined => {
    const { likes } = state;
    return !!likes.userLikes[articleId];
  };
};

export const getArticleTotalLikes = (articleId) => {
  return (state: IGlobalState): number | undefined => state.likes.articleLikes[articleId];
};

export const getInitUserLikes = (state: IGlobalState): SravniNewsSharedModelsLikesUserLikesResult =>
  state.initialUserLikes.data;
